import { SearchContext } from '@contexts';
import { useContext } from 'react';

export const useSearch = () => {
    return useContext(SearchContext);
}